import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import '../../../styles/react-tabs.css';

export const EcTab = Tab;
export const EcTabs = Tabs;
export const EcTabList = TabList;
export const EcTabPanel = TabPanel;
